import {Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-multiselect-dropdown',
    templateUrl: './multiselect-dropdown.html',
    styleUrls: ['./multiselect-dropdown.scss'],
    standalone: false
})
export class MultiSelectDropdownComponent implements OnInit, OnChanges {
  @Input() list: any[] = [];
  @Input() selectedDays: any[] = [];

  @Output() shareCheckedList = new EventEmitter();
  @Output() shareCheckedObjectsList = new EventEmitter();
  @Output() shareIndividualCheckedList = new EventEmitter();

  checkedList: any[];
  checkedObjects: any[] = [];
  currentSelected: {} = {};

  showDropDown: boolean = false;

  ngOnInit(): void {
    this.checkedList = [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDays'] && changes['selectedDays'].currentValue && this.selectedDays) {
      this.checkedObjects = [...this.selectedDays];
      this.updateCheckedStatus();
    }
  }

  getList() {
    if (this.list && this.list[0].id) {
      this.checkedObjects = [...this.selectedDays];
      this.updateCheckedStatus();

      return this.checkedObjects;
    } else {
      return this.checkedList;
    }
  }

  updateCheckedStatus() {
    this.list.forEach(item => {
      item.checked = this.selectedDays.some(day => day.id === item.id);
    });
  }

  setValue(element) {
    if (!element.id) {
      this.setSelectedValue(element.checked, element.name);
    } else {
      this.setSelectedObject(element.checked, element);
    }
  }

  removeElement(status, element) {
    if (!element.id) {
      this.setSelectedValue(status, element.name);
    } else {
      this.setSelectedObject(status, element);
    }
  }

  setSelectedValue(status: Boolean, value: String) {
    if (status) {
      this.checkedList.push(value);
    } else {
      var index = this.checkedList.indexOf(value);
      this.checkedList.splice(index, 1);
      this.uncheck(value);
    }
    this.currentSelected = {checked: status, name: value};

    this.shareCheckedlist();
  }

  setSelectedObject(status: Boolean, obj) {
    if (status) {
      this.checkedObjects.push(obj);
    } else {
      var index = this.checkedObjects.indexOf(obj);
      this.checkedObjects.splice(index, 1);
      this.uncheckObject(obj);
    }

    this.shareCheckedObjects();
  }

  shareCheckedlist() {
    this.shareCheckedList.emit(this.checkedList);
  }

  shareCheckedObjects() {
    this.shareCheckedObjectsList.emit(this.checkedObjects);
  }
  shareIndividualStatus() {
    this.shareIndividualCheckedList.emit(this.currentSelected);
  }

  uncheck(name) {
    for (var item of this.list) {
      if (item.name == name) {
        item.checked = false;
      }
    }
  }

  uncheckObject(object) {
    for (var item of this.list) {
      if (item.id == object.id) {
        item.checked = false;
      }
    }
  }

  toggleDropdown(toggle, event) {
    if (event.target.className !== 'fa fa-times') {
      this.showDropDown = toggle;
    }
  }
}
